import React, { PureComponent } from 'react';
import Radium from 'radium';
import { node, string } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';

import styles from './styles';

class ContactItem extends PureComponent {
  render() {
    const { Icon, href, contact, additionalInfo } = this.props;

    return (
      <div style={styles.contactItem}>
        <Icon style={styles.icon} />
        <div style={styles.phoneContact}>
          <a href={href} target="_blank" rel="noopener noreferrer" style={styles.link}>
            <UTLabel primary>{contact}</UTLabel>
          </a>
          {additionalInfo && <UTLabel>{additionalInfo}</UTLabel>}
        </div>
      </div>
    );
  }
}

ContactItem.propTypes = {
  Icon: node.isRequired,
  href: string.isRequired,
  contact: string.isRequired,
  additionalInfo: string
};

export default Radium(ContactItem);
